import ObjectScreen from '@components/v2/layout/ObjectScreen/ObjectScreen';
import * as R from 'ramda';
import { ReactNode } from 'react';
import LangEnum from '../../../../../../../../../lang/LangEnum';
import { Customer } from '../../../../../../../../customer/types/customer.types';
import { useTranslation } from '../../../../../../../../translation/TranslationContext';
import { getCustomerDocumentLabelAndValue } from '../../../../../../../utils/orderCustomerDocument.utils';

interface OrderCustomerReadOnlyFieldsProps {
  customer?: Customer;
}

const OrderCustomerReadOnlyFields = ({ customer }: OrderCustomerReadOnlyFieldsProps) => {
  const { translate } = useTranslation();
  const { customerDocumentLabel, customerDocumentValue } = getCustomerDocumentLabelAndValue({
    cpfcnpj: customer?.cpfcnpj,
    location: customer?.location,
    isPJ: customer?.isPJ,
  });

  const withFallback = (value?: ReactNode) =>
    R.isNil(value) || value === '' ? translate(LangEnum.GLOBAL_NOT_INFORMED) : value;

  return (
    <>
      <ObjectScreen.Field
        label={LangEnum.GLOBAL_COMMERCIAL_NAME}
        value={withFallback(customer?.commercialName)}
      />
      <ObjectScreen.Field
        label={LangEnum.GLOBAL_COMPANY_NAME}
        value={withFallback(customer?.companyName)}
      />
      <ObjectScreen.Field
        label={customerDocumentLabel}
        value={withFallback(customerDocumentValue)}
      />
    </>
  );
};

export default OrderCustomerReadOnlyFields;
